module.exports = __webpack_public_path__ + "static/img/tel.842fc6fe.png";